module.exports = __webpack_public_path__ + "img/0036_cocos.76be63d5.jpg";